import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppLocalStorage } from 'app/app-storage-manager/local-storage';
import { MiscService } from 'app/shared/misc.service';
import { environment } from 'environments/environment';
import { map, retry, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class NotificationsService {
    constructor(private http: HttpClient,  private miscService: MiscService) { }

    getAllNotifications = () => this.http.get(`${environment.API_URL}/merchant/${this.miscService.getMerchantDetails().merchant_id}/messages/all`).pipe(retry(3))
    
    deleteNotification = (notificationId) => this.http.post(`${environment.API_URL}/notification/${this.miscService.getMerchantDetails().merchant_id}/messages/delete/${notificationId}`, {}).pipe(retry(3))

    sendNotification = (requestBody) => this.http.post(`${environment.API_URL}/notifications/message/topic`, requestBody).pipe(retry(3))

    uploadFile = (formData) => this.http.post(`${environment.API_URL}/upload`, formData, {
        reportProgress : true,
        observe : 'events'
    })
}